import moment from 'moment'

/**
 * Builds the api load window (calendar-day strings) for the electron telemetry summary.
 *
 * Anchored to UTC so the fetched dataset is identical for every viewer: a viewer-local "today"
 * shifted the window by up to a day, which is why teammates in different timezones saw different
 * telemetry-log counts. The end is pushed one day forward so the current day is fully covered in
 * every hotel timezone (api-pms-receiver resolves these strings against the hotel timezone).
 *
 * @param {number} lookbackDays
 * @param {import('moment').Moment} [nowMoment] injectable clock for tests
 * @returns {{ startDate: string, endDate: string }}
 */
export function buildElectronTelemetryFetchWindow(lookbackDays, nowMoment = moment.utc()) {
  const nowUtc = nowMoment.clone().utc()
  return {
    startDate: nowUtc.clone().subtract(lookbackDays, 'days').format('YYYY-MM-DD'),
    endDate: nowUtc.clone().add(1, 'day').format('YYYY-MM-DD')
  }
}
